import emoji from 'markdown-it-emoji';
import subscript from 'markdown-it-sub';
import superscript from 'markdown-it-sup';
import footnote from 'markdown-it-footnote';
import deflist from 'markdown-it-deflist';
import abbreviation from 'markdown-it-abbr';
import insert from 'markdown-it-ins';
import mark from 'markdown-it-mark';
import tasklists from 'markdown-it-task-lists';
import imsize from '@tlbs/markdown-it-imsize-static-require';
import markdownItAttrs from 'markdown-it-attrs';
import multimdTable from 'markdown-it-multimd-table';
import mdColor from 'markdown-it-color';
import mila from './link';

export default function (md) {
  md
    .use(emoji)
    .use(subscript)
    .use(superscript)
    .use(footnote)
    .use(deflist)
    .use(abbreviation)
    .use(insert)
    .use(mark)
    .use(tasklists, { enabled: true })
    .use(imsize, { autofill: true })
    .use(markdownItAttrs, {
      leftDelimiter: '{',
      rightDelimiter: '}',
      allowedAttributes: [],  // empty array = all attributes are allowed
    })
    .use(mila, {
      pattern: /^https?:\/\//,
      attrs: {
        target: '_blank',
      },
    })
    .use(mdColor, {
      defaultClassName: '',
      inline: true,
    })
    .use(multimdTable, { enableRowspan: true, enableMultilineRows: true });
}
